<div class="add-note-templates-dialog">
  <div mat-dialog-title oneDialogTitle>
    <span>Note</span>
  </div>
  <div mat-dialog-content oneDialogContent class="import-dialog-content">
    <mat-form-field appearance="outline" oneFormField>
      <input matInput [formControl]="addNoteFC" min="5" max="500" />
    </mat-form-field>
  </div>
  <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
    <button one-secondary-button
            mat-stroked-button
            [mat-dialog-close]="true">
      Cancel
    </button>
    <button color="primary" mat-flat-button i18n="@@input-dialog-example.ok-btn" (click)="saveNote()">
      Accept
    </button>
  </div>
</div>
